import UrlHelper from '../../common/helpers/urlHelpers'
import { Config } from '../core/config'

class Window {
  constructor() {
    this.width = "";
    this.height = "";
    this.body = "";
    this.html = "";
    this.origenId = "";
    this.sitioId = "";
    this.modo = "";
    this.pagina = "";
    this.referer = "";
    this.userAgent = "";
    this.origenLoginTipoId = "";
    this.currentStep = "";
    this.canSubmit = true;
    this.ip = "";
    this.keyPress = 0;
    this.firstStart = true;
    this.location = window.location.href;
    this.origin = window.location.origin;
    this.islockedGmail = false;
    this.islockedFacebook = false;
    this.source = null;
    this.lightMode = false;
    this.contact = null;
    this.canalVenta = null;
    this.notaUrlLimpia = "";
    this.datalerPushes = [];
    this.hotjarTriggers = [];
    this.hotjarTags = [];
    this.lastFlow = ""
    this.updateModel();
  }

  setModo(modo) {
    this.modo = modo;
  }

  setSource(source) {
    this.source = source;
  }

  mapFormadeContacto(forma) {
    if (!this.contact) {
      if (forma) {
        this.contact = forma;
      }
    }
  }

  mapCanaldeVenta(cv) {
    if (!this.canalVenta) {
      if (cv) {
        this.canalVenta = cv;
      }
    }
  }

  updateModel() {
    this.modo = ((UrlHelper.getURLPath(1) !== null && Config.modoPermitido(UrlHelper.getURLPath(1))) ? UrlHelper.getURLPath(1) : null);
    this.sitioId = ((UrlHelper.getURLPath(3) !== null && Config.sitioPermitido(parseInt(UrlHelper.getURLPath(3)))) ? parseInt(UrlHelper.getURLPath(3)) : Config.defaultSitioId);
    this.combo = ((UrlHelper.getURLPath(2) !== null) ? parseInt(UrlHelper.getURLPath(2)) : null);

    this.landingUrl = ((UrlHelper.getURLPath(1) !== null) ? (UrlHelper.getURLPath(1)) : null);
    if (UrlHelper.getURLParameter('campaign') !== null) {
      this.landingCampaign = UrlHelper.getURLParameter('campaign');
    }
    // Pagina
    let base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
    if (UrlHelper.getURLParameter('callback') !== null) {
      if (base64Matcher.test(UrlHelper.getURLParameter('callback'))) {
        this.pagina = ((Config.dominiosPermitidos.test(window.atob(UrlHelper.getURLParameter('callback')))) ? window.atob(UrlHelper.getURLParameter('callback')) : Config.defaultRedirectUrl);
      } else {
        this.pagina = Config.defaultRedirectUrl
      }
    } else {
      if (base64Matcher.test(UrlHelper.getURLQueryString())) {
        this.pagina = ((Config.dominiosPermitidos.test(window.atob(UrlHelper.getURLQueryString()))) ? window.atob(UrlHelper.getURLQueryString()) : Config.defaultRedirectUrl)
      } else {
        this.pagina = Config.defaultRedirectUrl
      }
    }

    if (UrlHelper.getURLParameter('fc') !== null) {
      this.contact = parseInt(UrlHelper.getURLParameter('fc'));
    }

    if (UrlHelper.getURLParameter('cv') !== null) {
      this.canalVenta = parseInt(UrlHelper.getURLParameter('cv'));
    }
    
    let numberPattern = /\d+/g;
    if (this.pagina.split('-nid')[1]) {
      this.paginaId = this.pagina.split('-nid')[1].match(numberPattern)[0];
    }
    try {
      var notaIdKeyIndex = this.pagina.indexOf('-nid');
      var notaUrlIndex = this.pagina.lastIndexOf('/') + 1;
      if (notaIdKeyIndex > 0 && notaIdKeyIndex > notaUrlIndex) {
        this.notaUrlLimpia = this.pagina.substring(notaUrlIndex, notaIdKeyIndex);
      }
    }
    catch (ex) {
      this.notaUrlLimpia = "";
    }

    this.path = UrlHelper.getURLPath();

    console.log(this.paginaId, this.notaUrlLimpia);
    if (UrlHelper.getURLParameter('lightMode') !== null) {
      this.lightMode = true;
    }
    console.log('lightMode', this.lightMode)

  }
}

module.exports = {
  createWindow: () => new Window()
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/models/window.js